// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"108c6362","534":"b316cf23","543":"4d1615c8","564":"1bcd7f14","677":"20a20e7f","773":"11db589e","878":"8156f35d"}[chunkId] + ".chunk.css";
};